import { routes } from './site'

/**
 * Viking Spas page content. Edit here; the page reads these lists directly.
 * These are Viking product families to explore, not a list of local inventory.
 */

/** Official Viking Ascent II lifestyle photograph supplied by the owner. */
export const ascentII = {
  image:
    'https://cdn.magicpatterns.com/uploads/myv13hqCoJyU8uYCnj7S3x/VS_Ascent2_Lifestyle_White_Chestnut_2.png',
  alt: 'Viking Spas Ascent II hot tub in White and Chestnut in an attainable backyard setting',
  source: 'https://vikingspas.com/model/ascent/',
  specs: ['7 adults', 'Non-lounge seating', '86 x 86 x 36 in.', '50 jets', '240V / 60A'],
}

export const vikingReasons = [
  {
    title: 'Built close to home',
    body: 'A family-owned American manufacturer based in West Michigan.',
  },
  {
    title: 'A range of starting points',
    body:
      'Choices span more fully featured Elite models, practical Heirloom models, plug-in-friendly Element choices, and Chill Therapy.',
  },
  {
    title: 'Help after the comparison',
    body:
      'We help you understand seating, setup and everyday ownership without decoding a specification sheet.',
  },
]

export const vikingLineup = [
  {
    number: '01',
    name: 'Elite Series',
    body:
      'Viking’s most fully featured hot-tub series. The Ascent II shown on this page is one example of what the Elite Series includes.',
    linkLabel: 'Explore the Elite Series at Viking',
    href: 'https://vikingspas.com/series/elite-series/',
  },
  {
    number: '02',
    name: 'Heirloom Series',
    body: 'A practical middle path that balances added features with value.',
    linkLabel: 'Explore the Heirloom Series at Viking',
    href: 'https://vikingspas.com/series/heirloom-series/',
  },
  {
    number: '03',
    name: 'Element Series',
    body:
      'Straightforward, plug-in-friendly choices intended to make ownership approachable. Electrical requirements vary by model, so check the one you are considering.',
    linkLabel: 'Explore the Element Series at Viking',
    href: 'https://vikingspas.com/series/element-series/',
  },
  {
    number: '04',
    name: 'Chill Therapy',
    body: 'A purpose-built one-person cold-water option for a home fitness or wellness area.',
    linkLabel: 'See Chill Therapy at Pegasus',
    href: routes.coldPlunge,
  },
]
